/**
 * Модалка создания/редактирования семьи
 * Дата: 09.01.2026 - Создан для TODO-029 (Patient Families)
 * Связан с: frontend/src/pages/PatientFamilies.tsx
 */
import { useState, useEffect } from 'react';
import { Modal, Input, Button } from '@/components/ui';
import { PatientFamily, CreateFamilyRequest, UpdateFamilyRequest } from '@/api/types';
import { useCreateFamily, useUpdateFamily } from '@/hooks/useFamilies';

interface FamilyModalProps {
  isOpen: boolean;
  onClose: () => void;
  family?: PatientFamily | null;
  tenantId?: string;
}

export function FamilyModal({ isOpen, onClose, family, tenantId }: FamilyModalProps) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const createFamily = useCreateFamily();
  const updateFamily = useUpdateFamily();

  useEffect(() => {
    if (family) {
      setName(family.name);
      setPhone(family.phone_normalized);
    } else {
      setName('');
      setPhone('');
    }
  }, [family, isOpen]);

  const handleSubmit = () => {
    if (family) {
      // Редактирование
      const updateData: UpdateFamilyRequest = {};
      if (name !== family.name) updateData.name = name;
      updateFamily.mutate(
        { id: family.id, data: updateData, tenantId },
        { onSuccess: onClose }
      );
    } else {
      // Создание
      if (!name || !phone) return;
      const createData: CreateFamilyRequest = {
        name,
        phone_normalized: phone,
      };
      createFamily.mutate(
        { data: createData, tenantId },
        { onSuccess: onClose }
      );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={family ? 'Редактировать семью' : 'Создать семью'}
      size="md"
    >
      <div className="space-y-4">
        <Input
          label="Название семьи"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Например: Семья Гаджиевых"
          required
        />

        {!family && (
          <Input
            label="Номер телефона"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+7 920 785-03-78"
            required
          />
        )}

        {family && (
          <div className="text-sm text-neutral-500">
            Телефон: {family.phone_normalized}
          </div>
        )}

        <div className="flex justify-end gap-2 pt-4">
          <Button variant="secondary" onClick={onClose}>
            Отмена
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!name || (!family && !phone) || createFamily.isPending || updateFamily.isPending}
            testId={family ? 'btn-confirm-update-family' : 'btn-confirm-create-family'}
          >
            {family ? 'Сохранить' : 'Создать'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

